(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "@babel/runtime/helpers/defineProperty", "./index.less", "../popup", "../icon"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("@babel/runtime/helpers/defineProperty"), require("./index.less"), require("../popup"), require("../icon"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.defineProperty, global.index, global.popup, global.icon);
    global.unknown = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _defineProperty2, _index, _popup, _icon) {
  "use strict";

  var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  _defineProperty2 = _interopRequireDefault(_defineProperty2);
  _popup = _interopRequireDefault(_popup);
  _icon = _interopRequireDefault(_icon);

  var _components;

  var _default2 = {
    render: function render() {
      var _vm = this;

      var _h = _vm.$createElement;

      var _c = _vm._self._c || _h;

      return _c('div', {
        staticClass: "nx-landscape"
      }, [_c('nx-popup', {
        staticClass: "nx-landscape-popup",
        attrs: {
          "has-mask": _vm.hasMask,
          "position": _vm.position,
          "mask-closable": _vm.maskClosable,
          "transition": _vm.transition,
          "isWebviewFull": _vm.isWebviewFull,
          "backClosePopup": _vm.backClosePopup,
          "backClosePopupCustomEvent": _vm.backClosePopupCustomEvent
        },
        on: {
          "input": function input($event) {
            return _vm.$emit('input', false);
          },
          "show": function show($event) {
            return _vm.$emit('show');
          },
          "hide": function hide($event) {
            return _vm.$emit('hide');
          },
          "maskClick": function maskClick($event) {
            return _vm.$emit('maskClick');
          }
        },
        model: {
          value: _vm.isLandscapeShow,
          callback: function callback($$v) {
            _vm.isLandscapeShow = $$v;
          },
          expression: "isLandscapeShow"
        }
      }, [_c('div', {
        staticClass: "nx-landscape-body"
      }, [_c('div', {
        staticClass: "nx-landscape-content"
      }, [_vm.closeableBottom && _vm.position === 'bottom' ? _c('a', {
        staticClass: "nx-dialog-close",
        on: {
          "click": _vm.$_close
        }
      }, [_c('nx-icon', {
        attrs: {
          "name": "close2",
          "role": "button",
          "aria-label": "关闭"
        }
      })], 1) : _vm._e(), _vm._t("default")], 2), _vm.closable && _vm.position === 'center' ? _c('i', {
        staticClass: "nx-landscape-close-icon",
        attrs: {
          "tabindex": "1",
          "aria-label": "关闭",
          "role": "button"
        },
        on: {
          "click": _vm.$_close
        }
      }) : _vm._e()])])], 1);
    },
    name: 'nx-landscape',
    components: (_components = {}, (0, _defineProperty2.default)(_components, _popup.default.name, _popup.default), (0, _defineProperty2.default)(_components, _icon.default.name, _icon.default), _components),
    props: {
      value: {
        type: Boolean,
        default: false
      },
      position: {
        type: String,
        default: 'center'
      },
      transition: {
        type: String,
        default: 'nx-punch'
      },
      hasMask: {
        type: Boolean,
        default: true
      },
      maskClosable: {
        type: Boolean,
        default: false
      },
      closable: {
        type: Boolean,
        default: true
      },
      isWebviewFull: {
        type: Boolean,
        default: function _default() {
          if (location.href && location.href.indexOf('sink=1') > -1) {
            return true;
          } else {
            return false;
          }
        }
      },
      closeableBottom: {
        type: Boolean,
        default: false
      },
      backClosePopup: {
        type: Boolean,
        default: false
      },
      backClosePopupCustomEvent: {
        type: String,
        default: 'popstate'
      }
    },
    data: function data() {
      return {
        isLandscapeShow: this.value
      };
    },
    watch: {
      value: function value(val) {
        this.isLandscapeShow = val;
      }
    },
    methods: {
      $_close: function $_close() {
        this.isLandscapeShow = false;
        this.$emit('close');
      }
    }
  };
  _exports.default = _default2;
});